import { AppBar, Grid, makeStyles, Tab, Tabs } from '@material-ui/core';
import i18n from 'i18n';
import {
  CompanyData,
  PermissionsData,
  RolesEnum,
} from 'modules/authenticate/interfaces';
import React from 'react';
import { getPartnerRequest } from 'modules/partners/actions';
import { connect } from 'react-redux';
import { useHistory, useParams } from 'react-router';
import ApplicationState from 'store/interfaces';
import clsx from 'clsx';
import { inAdminView, inSuperAdminView, inOperatorView } from 'utils/role';
import { PartnerFormFields } from 'modules/partners/interfaces';
import styles from './styles';

const useStyles = makeStyles(styles);

interface Props {
  role?: RolesEnum;
  companySelected: CompanyData | null;
  permissions: PermissionsData | undefined;
  current: 'configuration' | 'servers' | 'instances' | 'custom-front';
  partnerDetails: PartnerFormFields | null;
  getPartnerRequest: (id: string) => void;
}

const NavBarPartners = ({
  role,
  companySelected,
  permissions,
  current,
  partnerDetails,
  getPartnerRequest,
}: Props) => {
  const classes = useStyles();
  const { id } = useParams<{ id: string }>();
  const history = useHistory();

  const items = [
    {
      label: i18n.t('SETTINGS_KEY'),
      slug: 'configuration',
      hidden: !!permissions && !permissions.edit_partner_details,
    },
    {
      label: i18n.t('SERVERS_KEY'),
      slug: 'servers',
      hidden: !!permissions && !permissions.list_partner_servers,
    },
    {
      label: i18n.t('INSTANCES_KEY'),
      slug: 'instances',
      hidden:
        (!!permissions && !permissions.list_partner_instances) ||
        !partnerDetails?.show_instances_list,
    },
    {
      label: i18n.t('GROUPS_PAGE.FRONTEND_CUSTOMIZATION_KEY'),
      slug: 'custom-front',
      hidden: !!permissions && !permissions.edit_user_theme_config,
    },
  ].filter(item => !item.hidden);

  React.useEffect(() => {
    getPartnerRequest(id);
  }, [getPartnerRequest, id]);

  return (
    <Grid item xs={12} className={classes.rootBar}>
      <AppBar
        position="static"
        color="default"
        className={clsx({
          [classes.barGreen]: inAdminView(role, companySelected),
          [classes.barGray]: inSuperAdminView(role, companySelected),
          [classes.barBlue]: inOperatorView(role, companySelected),
          [classes.barYellow]: companySelected,
        })}
      >
        <Tabs
          value={items.findIndex(item => item.slug === current)}
          variant="scrollable"
          scrollButtons="auto"
        >
          {items.map(({ label, slug }) => (
            <Tab
              id={`partner-navbar-${slug}`}
              key={slug}
              label={label}
              onClick={() => history.push(`/partners/${id}/${slug}`)}
              className={clsx({
                [`${classes.tabGreen} ${classes.tab}`]: inAdminView(
                  role,
                  companySelected
                ),
                [`${classes.tabGray} ${classes.tab}`]: inSuperAdminView(
                  role,
                  companySelected
                ),
                [`${classes.tabBlue} ${classes.tab}`]: inOperatorView(
                  role,
                  companySelected
                ),
                [`${classes.tabYellow} ${classes.tab}`]: companySelected,
              })}
            />
          ))}
        </Tabs>
      </AppBar>
    </Grid>
  );
};

const mapStateToProps = ({
  authenticate: { data, companySelected },
  partners: { partnerDetails },
}: ApplicationState) => ({
  permissions: data?.permissions,
  companySelected,
  partnerDetails,
  role: data?.role,
});

export default connect(mapStateToProps, { getPartnerRequest })(NavBarPartners);
